module.exports = __webpack_public_path__ + "static/img/dialog_icon.fece42b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/jcxy-dialog/assets/dialog_icon.svg
// module id = O6VK
// module chunks = 33